import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setCourseList, setloading, seterror, resetCourseListStudent
} from "../reducers/getAllCourseListByStudentReducer";

const getAllCourseListByStudent = (
    student_id: any,
    token: any,
    time_period?: string,
    start_date?: string,
    end_date?: string
  ) => async (dispatch: Dispatch) => {
    dispatch(setloading(true));
    try {
      // Prepare parameters object
      const params: any = {
        student_id: student_id,
      };
  
      // Add optional parameters if provided
      if (time_period) {
        params.time_period = time_period;
      }
      if (start_date) {
        params.start_date = start_date;
      }
      if (end_date) {
        params.end_date = end_date;
      }
  
      // API endpoint examples:
      // Custom: /analytics/dashboard/student/get-enrolled-course-list/?student_id=295060&time_period=custom&start_date=2025-03-10&end_date=2025-03-12
      // Month: /analytics/dashboard/student/get-enrolled-course-list/?student_id=295060&time_period=month&start_date=Mar-2025
      // Week: /analytics/dashboard/student/get-enrolled-course-list/?student_id=295060&time_period=week&start_date=Mar-2025
      // Year: /analytics/dashboard/student/get-enrolled-course-list/?student_id=295060&time_period=year&start_date=2025
      // Note: Dates for custom periods are sent in YYYY-MM-DD format
      const result = await api.get(
       `/analytics/dashboard/student/get-enrolled-course-list/`,
        {
          params: params,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        }
      );
  
      if (result.status === 200) {
        dispatch(setloading(false));
        dispatch(setCourseList(result?.data?.courses || []));
        
      } else {
        dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
      }
    } catch (error:any) {
      dispatch(setloading(false));
      dispatch(
        seterror(error.response?.data?.message || "Something Went Wrong!")
      );
    }
  };
  
  export { getAllCourseListByStudent, resetCourseListStudent };

